import { Modal, Label, TextInput, Button } from "flowbite-react";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
  value: Yup.number()
    .positive("Valor deve ser maior que zero")
    .required("Obrigatório"),
  installments: Yup.number()
    .min(1, "Mínimo 1 parcela")
    .required("Obrigatório"),
  parcels: Yup.array().of(
    Yup.object({
      date: Yup.date().required("Data obrigatória"),
      amount: Yup.number()
        .positive("Valor deve ser maior que zero")
        .required("Obrigatório"),
    })
  ),
});

export const ModalEditBilletDate = ({ totalValue, onClose, onConfirm }) => {
  return (
    <Modal show={true} onClose={onClose}>
      <Modal.Header className="text-black">Informações do Boleto</Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            value: totalValue,
            installments: 1,
            parcels: [{ date: "", amount: "" }],
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => onConfirm({ ...values })}
        >
          {({ values, errors, touched, setFieldValue }) => {
            const redistributeParcels = (totalValue, count) => {
              const amountPerParcel = totalValue && count > 0 ? totalValue / count : 0;
              const newParcels = Array.from({ length: count }, (_, i) => ({
                date: values.parcels?.[i]?.date || "",
                amount: amountPerParcel.toFixed(2),
              }));
              setFieldValue("parcels", newParcels);
            };

            return (
              <Form className="space-y-4">
                <div>
                  <Label htmlFor="value" value="Valor Total" className="text-black" />
                  <Field
                    as={TextInput}
                    id="value"
                    name="value"
                    type="number"
                    step="0.01"
                    placeholder="Ex: 1200.00"
                    onChange={(e) => {
                      const newValue = parseFloat(e.target.value) || 0;
                      setFieldValue("value", newValue);
                      redistributeParcels(newValue, values.installments);
                    }}
                  />
                  {errors.value && touched.value && (
                    <p className="text-red-500 text-sm mt-1">{String(errors.value)}</p>
                  )}
                </div>

                <div>
                  <Label htmlFor="installments" value="Quantidade de Parcelas" className="text-black" />
                  <Field
                    as={TextInput}
                    id="installments"
                    name="installments"
                    type="number"
                    placeholder="Ex: 3"
                    min="1"
                    onChange={(e) => {
                      const newCount = Number(e.target.value) || 1;
                      setFieldValue("installments", newCount);
                      redistributeParcels(values.value, newCount);
                    }}
                  />
                  {errors.installments && touched.installments && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.installments}
                    </p>
                  )}
                </div>

                <FieldArray name="parcels">
                  {() => (
                    <div className="space-y-3">
                      {values.parcels.map((_parcel, index) => (
                        <div
                          key={index}
                          className="grid grid-cols-2 gap-4 border p-3 rounded-md"
                        >
                          <div>
                            <Label
                              htmlFor={`parcels.${index}.date`}
                              value={`Data da Parcela ${index + 1}`}
                            />
                            <Field
                              as={TextInput}
                              id={`parcels.${index}.date`}
                              name={`parcels.${index}.date`}
                              type="date"
                            />
                          </div>

                          <div>
                            <Label
                              htmlFor={`parcels.${index}.amount`}
                              value={`Valor da Parcela ${index + 1}`}
                            />
                            <Field
                              as={TextInput}
                              id={`parcels.${index}.amount`}
                              name={`parcels.${index}.amount`}
                              type="number"
                              step="0.01"
                              placeholder="Ex: 400.00"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </FieldArray>

                <div className="flex justify-end pt-4 border-t">
                  <Button color="gray" onClick={onClose} type="button">
                    Cancelar
                  </Button>
                  <Button type="submit" className="ml-2">
                    Confirmar
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

